import {
  NETWORK_ROUTES,
  adminNetworkListResponseSchema,
  reassignSponsorResponseSchema,
  type BranchRecalc,
  type AdminNetworkItem,
  type NetworkNode,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

const NO_PREFIX = { baseUrl: "" } as const;

/** El unilevel del panel: la lista plana con la que se arma el árbol. */
export async function listAdminNetwork(): Promise<AdminNetworkItem[]> {
  const data = await authFetch(NETWORK_ROUTES.adminList, adminNetworkListResponseSchema, NO_PREFIX);
  return data.items;
}

/**
 * Mover una rama de patrocinador. `newSponsorCode` en `null` la cuelga
 * de la raíz. El motivo es OBLIGATORIO: mover el árbol mueve el dinero
 * de todos, y el porqué queda registrado en el nodo.
 */
export async function reassignSponsor(
  userId: string,
  newSponsorCode: string | null,
  reason: string,
): Promise<{ node: NetworkNode; recalculated: BranchRecalc | null }> {
  const data = await authFetch(
    NETWORK_ROUTES.adminReassign(userId),
    reassignSponsorResponseSchema,
    { ...NO_PREFIX, method: "PATCH", body: { newSponsorCode, reason } },
  );
  return { node: data.node, recalculated: data.recalculated };
}
